"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _themeTools = require("@chakra-ui/theme-tools");
/**
 * The "base" breakpoint is Chakra's default non-responsive value (from 0 upwards).
 * While we don't explicitly enable a "mobile" breakpoint, we can consider "base" and
 * "mobile" the same for all intents and purposes for mobile-first responsive styling.
 * @see https://chakra-ui.com/docs/features/responsive-styles#customizing-breakpoints
 */
var breakpoints = (0, _themeTools.createBreakpoints)({
  mobileXL: '30rem',
  // 480px
  tablet: '48rem',
  // 768px
  desktop: '64rem',
  // 1024px
  desktopXL: '90rem' // 1440px
});
var _default = exports["default"] = breakpoints;